const languageList: any = {
    'de'     : 'Deutsch',
    'zh-CN'  : '中文（简体）',
    'zh-HK'  : '中文繁体',
    'en'     : 'English',
    'ja'     : '日本語',
    'ko'     : '한국어‫',
    'ms'     : 'Bahasa Melayu',
    'it-CH'  : 'italiano',
    'fr-CH'  : 'français',
    'tr'     : 'Türkçe',
    'ru'     : 'Русский',
    'th'     : 'ไทย',
    'ar'     : 'العربية',
    'he'     : 'עברית',
    'es'     : 'Español',
    'vi'     : 'Tiếng Việt',
    'pt-br'  : 'Português',
    'id'     : 'Bahasa Indonesia'
}

const getLanguageDesc = (val: string) => {
    var desc = languageList[val] || val
    return desc
}

const getLangCode = (val: string) => {

    var lang = val.toLowerCase()
    var language = 'en'

    language = lang.indexOf('en') > -1 ? 'en' : language
    language = lang.indexOf('zh-cn') > -1 ? 'zh-CN' : language
    language = lang.indexOf('zh-hk') > -1 ? 'zh-HK' : language
    language = lang === 'zh' ? 'zh-CN' : language
    language = lang === 'zh-tw' ? 'zh-HK' : language

    language = lang.indexOf('fr') > -1 ? 'fr-CH' : language
    language = lang.indexOf('pt') > -1 ? 'pt-br' : language
    language = lang.indexOf('ja') > -1 ? 'ja' : language

    language = (languageList[val] != undefined && languageList[val] != null) ? val : language

    return language
}

export { getLanguageDesc, getLangCode }